module.exports = __webpack_public_path__ + "img/popular4.11689392.png";